require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setComponentProps = setComponentProps;
exports.updateComponentProps = updateComponentProps;
exports.removeComponentProps = removeComponentProps;

var _constants = require('../constants');

var _constants2 = require('../utils/constants');

var getfilteredOptions = function getfilteredOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filteredOptions = {};
  Object.keys(options).forEach(function (option) {
    if (_constants2.validProps.includes(option)) {
      filteredOptions[option] = options[option];
    }
  });
  return filteredOptions;
};

function setComponentProps(component, options, componentType) {
  return {
    type: _constants.SET_PROPS,
    component: component,
    options: getfilteredOptions(_extends({}, options, {
      componentType: componentType
    }))
  };
}

function updateComponentProps(component, options, componentType) {
  return {
    type: _constants.UPDATE_PROPS,
    component: component,
    options: getfilteredOptions(_extends({}, options, {
      componentType: componentType
    }))
  };
}

function removeComponentProps(component) {
  return {
    type: _constants.REMOVE_PROPS,
    component: component
  };
}